import { searchResults } from './state';

export default (placeholder) => ({
  state: searchResults(placeholder),
  namespaced: true,
});
